import React, { Fragment, useEffect, useRef, useState } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  tableCellClasses,
  IconButton,
  CircularProgress,
  Chip,
  Grid,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  ListItemText,
  Tooltip,
  Checkbox,
  InputAdornment,
  TextField,
  RadioGroup,
  Radio,
  FormControlLabel,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import {
  AllocateIcon,
  CheckIcon,
  EyeIcon,
  FontFamily,
  Images,
  MessageIcon,
  PendingIcon,
  RequestBuyerIdIcon,
} from "assets";
import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";
import Colors from "assets/Style/Colors";
import { CircleLoading } from "components/Loaders";
import { ErrorToaster, SuccessToaster } from "components/Toaster";
import FinanceStatusDialog from "components/Dialog/FinanceStatusDialog";
import AllocateStatusDialog from "components/Dialog/AllocateStatusDialog";
import AllocateDialog from "components/Dialog/AllocateDialog";
import CustomerServices from "services/Customer";
import { makeStyles } from "@mui/styles";
import Pagination from "components/Pagination";
import {
  Debounce,
  encryptData,
  formatPermissionData,
  handleExportWithComponent,
} from "utils";
import InputField from "components/Input";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { addPermission } from "redux/slices/navigationDataSlice";
import SimpleDialog from "components/Dialog/SimpleDialog";
import { PrimaryButton } from "components/Buttons";
import SelectField from "components/Select";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import SearchIcon from "@mui/icons-material/Search";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { PDFExport } from "@progress/kendo-react-pdf";
import moment from "moment";
import CommissionServices from "services/Commission";
import LabelCustomInput from "components/Input/LabelCustomInput";
import { showErrorToast, showPromiseToast } from "components/NewToaster";
import { adjustSectionValue } from "@mui/x-date-pickers/internals/hooks/useField/useField.utils";
import VisaServices from "services/Visa";
import DatePicker from "components/DatePicker";
import SystemServices from "services/System";
import UploadFile from 'components/UploadFile';
import { CleanTypes, getFileSize } from 'utils';
import instance from 'config/axios';
import routes from 'services/System/routes';
import UploadFileSingle from "components/UploadFileSingle";
import { useAuth } from "context/UseContext";
import VisaDetail from "../Visa/VisaDetail";
import ExcelJS from "exceljs"
import { setExcelJsDateCell, setExcelJsAutoFilter } from "utils/excelDate";

import { getListState, saveListState } from "utils/listState";

const LIST_STATE_KEY = "renewedVisaList";
// *For Table Style
const Row = styled(TableRow)(({ theme }) => ({
  border: 0,
}));

const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontFamily: "Public Sans",
    border: "1px solid #EEEEEE",
    padding: "15px",
    textAlign: "left",
    whiteSpace: "nowrap",
    color: "#434343",
    paddingRight: "50px",
    background: "transparent",
    fontWeight: "bold",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: "Public Sans",

    textWrap: "nowrap",
    padding: "5px !important",
    paddingLeft: "15px !important",

    ".MuiBox-root": {
      display: "flex",
      gap: "6px",
      alignItems: "center",
      justifyContent: "center",
      ".MuiBox-root": {
        cursor: "pointer",
      },
    },
    svg: {
      width: "auto",
      height: "24px",
    },
    ".MuiTypography-root": {
      textTransform: "capitalize",
      fontFamily: FontFamily.NunitoRegular,
      textWrap: "nowrap",
    },
    ".MuiButtonBase-root": {
      padding: "8px",
      width: "28px",
      height: "28px",
    },
  },
}));

const useStyles = makeStyles({
  loaderWrap: {
    display: "flex",
    height: 100,
    "& svg": {
      width: "40px !important",
      height: "40px !important",
    },
  },
});

function VisaList() {
  const {
    register,
    handleSubmit,
    getValues,
    control,
    setValue,
    formState: { errors },
  } = useForm();
  const {
    register: registerFilter,
    getValues: getValuesFilter,
    setValue: setValueFilter,
    formState: { errors: errorsFilter },
  } = useForm();
  const {
    register: register2,
    handleSubmit: handleSubmit2,
    setValue: setValue2,
    getValues: getValues2,
    formState: { errors: errors2 },
  } = useForm();
  const {
    register: register3,
    handleSubmit: handleSubmit3,
    setValue: setValue3,
    getValues: getValues3,
    formState: { errors: errors3 },
  } = useForm();
  const {
    register: register5,
    handleSubmit: handleSubmit5,
    setValue: setValue5,
    formState: { errors: errors5 },
  } = useForm();
  const {
    register: register6,
    handleSubmit: handleSubmit6,
    setValue: setValue6,
  } = useForm();
  const navigate = useNavigate();
  const classes = useStyles();
  const dispatch = useDispatch();
  const contentRef = useRef(null);
  const [statusDialog, setStatusDialog] = useState(false);
  const [paymentDialog, setPaymentDialog] = useState(false);
  const [uploadedSize, setUploadedSize] = useState(0);
  const [progress, setProgress] = useState(0);
  const [slipDetail, setSlipDetail] = useState([]);
  const [document, setDocument] = useState(null);
  const [requestDialog, setRequestDialog] = useState(false)


  const allowFilesType = [
    'image/png',
    'image/jpg',
    'image/jpeg',
    'application/pdf',
    'application/vnd.ms-excel',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  ];

  const tableHead = [
    { name: "VR No.", key: "" },
    { name: "Date", key: "created_at" },
    { name: "Customer", key: "created_at" },
    { name: "Candidate Name", key: "created_at" },
    { name: "Passport Number", key: "created_at" },
    { name: "Fee", key: "visa_rate" },
    { name: "VAT", key: "visa_rate" },
    { name: "Request Status", key: "" },
    { name: "Payment Status", key: "" },
    { name: "Status", key: "" },
    { name: "Actions", key: "" },

  ];
  //   state for visaprocessing use it later saraib
  //  const [renewVisas, setrenewVisas] = useState([])
  const [renewVisas, setRenewVisas] = useState([])
  const handleUploadDocument = async (e) => {
    try {
      e.preventDefault();
      const file = e.target.files[0];
      let arr = [
        {
          name: file?.name,
          file: "",
          type: file?.type.split("/")[1],
          size: getFileSize(file.size),
          isUpload: false,
        },
      ];

      if (allowFilesType.includes(file.type)) {
        // Add the current date before the file name to ensure uniqueness
        const currentDate = new Date().toISOString().split('T')[0]; // e.g., "2024-08-23"
        const uniqueFileName = `${currentDate}_${file.name}`;

        // Create a new file with the date-prefixed name
        const newFile = new File([file], uniqueFileName, { type: file.type });

        // Upload the file with the new name
        const path = await handleUpload(newFile, arr);

        console.log('Uploaded file path:', path);
        console.log(path, 'pathpathpath');

        // Clear the file input after processing
        e.target.value = "";

        return path;
      } else {
        ErrorToaster(`Only ${CleanTypes(allowFilesType)} formats is supported`);
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };


  const handleUpload = async (file, docs) => {
    setProgress(0);
    try {
      const formData = new FormData();
      formData.append("document", file);
      console.log(file);
      const { data } = await instance.post(routes.uploadDocuments, formData, {
        onUploadProgress: (progressEvent) => {
          const uploadedBytes = progressEvent.loaded;
          const percentCompleted = Math.round(
            (uploadedBytes * 100) / progressEvent.total
          );

          setProgress(percentCompleted);
          console.log(getFileSize(uploadedBytes));
          setUploadedSize(getFileSize(uploadedBytes));
        },
      });
      if (data) {
        docs[0].isUpload = true;
        docs[0].file = data?.data?.nations;
        setSlipDetail(docs);
        console.log(data, 'asddasasd');
        return data?.data?.path

      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const [loader, setLoader] = useState(false);

  const [sort, setSort] = useState("asc");

  // *For Customer Queue
  const [customerQueue, setCustomerQueue] = useState([
    { id: 1, name: "asdasd" },
    { id: 1, name: "asdasd" },
  ]);

  // *For setPermissions
  const [totalCount, setTotalCount] = useState(0);
  const [pageLimit, setPageLimit] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedVisa, setSelectedVisa] = useState(null);


  const [itemAmount, setItemAmount] = useState();
  const [status, setStatus] = useState();
  const [status2, setStatus2] = useState(null);
  const [date, setDate] = useState(null);
  const [paymentType, setPaymentType] = useState(null);
  const [banks, setBanks] = useState([]);
  const [selectedBank, setSelectedBank] = useState(null);
  const { user, userLogout } = useAuth();
  const [rates, setRates] = useState()
  const [buttonDisabled, setButtonDisabled] = useState(false)
  const [fromDate, setFromDate] = useState(null)
  const [toDate, setToDate] = useState(null)
  const [visas2, setVisas2] = useState([])
  const [newExpiryDate, setNewExpiryDate] = useState(null)
  const [approvalDate, setApprovalDate] = useState(null)
  const [cancelType, setCancelType] = useState("inside")
  const [editDialog, setEditDialog] = useState(false)
  const [editPaymentDialog, setEditPaymentDialog] = useState(false)
  const [editTenure, setEditTenure] = useState("1 year")
  const [editPassportExpiry, setEditPassportExpiry] = useState(null)
  const [editSkipMedical, setEditSkipMedical] = useState(false)
  const [editSkipEid, setEditSkipEid] = useState(false)

  // *For Filters
  const [filters, setFilters] = useState({});

  const getRenewalYears = (visaTenure) => {
    if (!visaTenure) return null;
    if (visaTenure.includes("2")) return 2;
    if (visaTenure.includes("1")) return 1;
    return null;
  };

  // Skip Medical / Skip EID selected on the renewal request itself
  const getSkippedRenewalFlags = (visa) => ({
    skipMedical: Boolean(visa?.skip_medical),
    skipEid: Boolean(visa?.skip_eid),
  });

  // Customer renewal rate, using the "without Medical / EID" rates when those steps are skipped
  const getRenewalChargeForVisa = (visa) => {
    if (!visa) return 0;

    const customer = visa?.visa?.customer || visa?.customer || {};
    const years = getRenewalYears(visa?.candidate?.visa_tenure);
    if (!years) return 0;

    const prefix = years === 2 ? "two_year" : "one_year";
    const { skipMedical, skipEid } = getSkippedRenewalFlags(visa);

    let key = null;
    if (skipMedical && skipEid) key = `${prefix}_renewal_without_both`;
    else if (skipMedical) key = `${prefix}_renewal_without_medical`;
    else if (skipEid) key = `${prefix}_renewal_without_eid`;

    const specialRate = key ? customer?.[key] : null;
    const rate = specialRate !== null && specialRate !== undefined && specialRate !== "" ? specialRate : customer?.[`${prefix}_renewal`];
    return Number.parseFloat(rate || 0) || 0;
  };

  const getCalculatedNewExpiryDate = (visa) => {
    const years = getRenewalYears(visa?.candidate?.visa_tenure);
    const currentExpiry = visa?.candidate?.visa_expiry;
    if (!years || !currentExpiry) return null;

    const baseDate = moment(currentExpiry);
    if (!baseDate.isValid()) return null;

    return baseDate.add(years, "years").toDate();
  };

  const RENEW_CLOSED_STATUSES = ["Renewed", "Rejected", "Canceled", "Absconder"];

  const normalizeRenewStep = (value) => {
    const s = (value || "").toString().trim().toLowerCase();
    if (s === "eid" || s.includes("emirate")) return "eid";
    if (s.includes("medical")) return "medical";
    return s;
  };

  // Next allowed steps: Medical -> EID -> Renewed (skipped steps are hidden),
  // plus Rejected (once approved and paid) to close the renewal
  const getRenewStatusOptions = (visa) => {
    const { skipMedical, skipEid } = getSkippedRenewalFlags(visa);
    const done = new Set((visa?.statuses || []).map((st) => normalizeRenewStep(st?.status)));
    const medicalDone = skipMedical || done.has("medical");
    const eidDone = skipEid || done.has("eid");

    const statuses = [];
    if (!done.has("in process")) statuses.push({ id: "In Process", name: "In Process" });
    if (!skipMedical && !done.has("medical")) statuses.push({ id: "Medical", name: "Medical" });
    if (!skipEid && !done.has("eid") && medicalDone) statuses.push({ id: "EID", name: "EID" });
    if (medicalDone && eidDone) statuses.push({ id: "Renewed", name: "Renewed" });
    // Rejection is only possible once the renewal request is approved and paid
    if (visa?.request_status?.toLowerCase() === "approved" && visa?.payment_status?.toLowerCase() === "paid") {
      statuses.push({ id: "Rejected", name: "Rejected" });
    }
    return statuses;
  };

  // *For Permissions
  const [permissions, setPermissions] = useState();

  const [loading, setLoading] = useState(false);

  // *For Get Customer Queue

  const UpdateStatus = async () => {
    // Document / passport validation is done when the renewal request is created
    if (!document) {
      showErrorToast('Please upload document');
      return;
    }
    if (!getValues('date') || !moment(getValues('date')).isValid()) {
      showErrorToast('Please select date');
      return;
    }

    setButtonDisabled(true)
    try {
      let obj = {
        status: status.id,
        id: selectedVisa?.id,
        candidate_id: selectedVisa?.candidate_id,
        visa_expiry: moment(selectedVisa?.candidate?.visa_expiry).format('MM-DD-YYYY'),
        visa_tenure: selectedVisa?.candidate?.visa_tenure,
        date: moment(getValues('date')).format('MM-DD-YYYY'),
        document: document,
        ...(status?.id === "Renewed" && newExpiryDate
          ? { new_expiry_date: moment(newExpiryDate).format("MM-DD-YYYY") }
          : {}),
        ...((status?.id === "Rejected" || status?.id === "Canceled")
          ? { rejection_charges: getValues("rejectionCharges") || 0 }
          : {}),
        ...(status?.id === "Canceled"
          ? { additional_type: cancelType, grace_period: getValues("grace") }
          : {}),
      };

      const promise = VisaServices.UpdateVisaProcessingStatus(obj);

      showPromiseToast(
        promise,
        "Saving...",
        "Added Successfully",
        "Something Went Wrong"
      );

      // Await the promise and then check its response
      const response = await promise;
      if (response?.responseCode === 200) {
        setStatusDialog(false);
        setDocument(null)
        setValue("rejectionCharges", "")
        setValue("grace", "")
        getRenewList()
      }
    } catch (error) {
      console.log(error);
    } finally {
      setButtonDisabled(false)
    }
  };
  const UpdateRequestStatus = async () => {
    if (!approvalDate || !moment(approvalDate).isValid()) {
      showErrorToast('Please select date');
      return;
    }
    try {
      let obj = {
        request_status: status.id,
        id: selectedVisa?.id,
        date: moment(approvalDate).format('MM-DD-YYYY'),
      };

      const promise = VisaServices.UpdateRequestStatus(obj);

      showPromiseToast(
        promise,
        "Saving...",
        "Added Successfully",
        "Something Went Wrong"
      );

      // Await the promise and then check its response
      const response = await promise;
      if (response?.responseCode === 200) {
        setRequestDialog(false);
        setApprovalDate(null);
        getRenewList()
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Edit renewal request (before approval) - candidate name and In/Out type are locked
  const openEditRequest = (item) => {
    const candidate = item?.candidate || {};
    setSelectedVisa(item);
    setEditTenure(candidate?.visa_tenure?.includes("2") ? "2 year" : "1 year");
    setEditPassportExpiry(candidate?.passport_expiry ? new Date(candidate?.passport_expiry) : null);
    setEditSkipMedical(Boolean(item?.skip_medical));
    setEditSkipEid(Boolean(item?.skip_eid));
    [
      "employee_id", "phone", "email", "camp_location", "passport_number", "visa_designation",
      "salary_basic", "salary_allowance", "end_consumer", "end_consumer_company",
    ].forEach((field) => setValue5(field, candidate?.[field] ?? ""));
    setEditDialog(true);
  };

  const EditRequest = async (formData) => {
    try {
      const basic = Number.parseFloat(formData?.salary_basic || 0) || 0;
      const allowance = Number.parseFloat(formData?.salary_allowance || 0) || 0;
      let obj = {
        id: selectedVisa?.id,
        skip_medical: editSkipMedical,
        skip_eid: editSkipEid,
        candidate: {
          employee_id: formData?.employee_id,
          visa_tenure: editTenure,
          phone: formData?.phone,
          email: formData?.email,
          camp_location: formData?.camp_location,
          passport_number: formData?.passport_number,
          passport_expiry: editPassportExpiry ? moment(editPassportExpiry).format('MM-DD-YYYY') : undefined,
          visa_designation: formData?.visa_designation,
          salary_basic: basic,
          salary_allowance: allowance,
          salary_total: basic + allowance,
          end_consumer: formData?.end_consumer,
          end_consumer_company: formData?.end_consumer_company,
        },
      };

      const promise = VisaServices.EditProcessingRequest(obj);
      showPromiseToast(promise, "Saving...", "Updated Successfully", "Something Went Wrong");
      const response = await promise;
      if (response?.responseCode === 200) {
        setEditDialog(false);
        getRenewList()
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Edit payment of a paid renewal (it can not be marked unpaid)
  const EditPayment = async (formData) => {
    if (!date || !moment(date).isValid()) {
      showErrorToast('Please select payment date');
      return;
    }
    try {
      let obj = {
        id: selectedVisa?.id,
        payment_date: moment(date).format('MM-DD-YYYY'),
        payment_type: paymentType?.name,
        description: formData?.edit_description,
      };

      const promise = VisaServices.UpdateProcessingPayment(obj);
      showPromiseToast(promise, "Saving...", "Updated Successfully", "Something Went Wrong");
      const response = await promise;
      if (response?.responseCode === 200) {
        setEditPaymentDialog(false);
        getRenewList()
      }
    } catch (error) {
      console.log(error);
    }
  };


  const handleDate2 = (newDate) => {
    try {
      // eslint-disable-next-line eqeqeq
      if (newDate == "Invalid Date") {
        setFromDate("invalid");
        return;
      }
      setFromDate(new Date(newDate));
    } catch (error) {
      ErrorToaster(error);
    }
  };
  const handleDate3 = (newDate) => {
    try {
      // eslint-disable-next-line eqeqeq
      if (newDate == "Invalid Date") {
        setToDate("invalid");
        return;
      }
      setToDate(new Date(newDate));
    } catch (error) {
      ErrorToaster(error);
    }
  };
  const UpdatePaymentStatus = async (formData) => {

    try {
      const renewalCharge = getRenewalChargeForVisa(selectedVisa);
      let obj = {
        payment_date: date,
        customer_id: selectedVisa?.visa?.customer?.id,
        payment_type: paymentType?.name,
        candidate_id: selectedVisa?.candidate_id,
        id: selectedVisa?.id,
        amount: formData?.amount,
        tax: (renewalCharge * 0.05).toFixed(2),
        bank_id: selectedBank?.id,
        description: formData?.description,
      };

      const promise = VisaServices.updateProcessingPaymentStatus(obj);
      console.log(promise);

      showPromiseToast(
        promise,
        "Saving...",
        "Added Successfully",
        "Something Went Wrong"
      );

      // Await the promise and then check its response
      const response = await promise;
      if (response?.responseCode === 200) {
        setPaymentDialog(false);
        getRenewList()
      }
    } catch (error) {
      console.log(error);
    }
  };



  const handleDate = (newDate) => {
    try {
      // eslint-disable-next-line eqeqeq
      if (newDate == "Invalid Date") {
        setDate("invalid");
        return;
      }
      setDate(new Date(newDate));
    } catch (error) {
      ErrorToaster(error);
    }
  };
  const getRenewList = async (page, limit, filter) => {
    // setLoader(true)
    console.log(filter);

    try {
      const Page = page ? page : currentPage
      const Limit = limit ? limit : pageLimit
      // No filter passed (reload after an action) keeps the current filters, null (Reset) clears them
      const Filter = filter === null ? {} : filter ? { ...filters, ...filter } : (filters || {})
      setCurrentPage(Page)
      setPageLimit(Limit)
      setFilters(Filter)
      saveListState(LIST_STATE_KEY, { filters: Filter, page: Page, limit: Limit })
      console.log('asasd');
      let params = {
        page: Page,
        limit: Limit,
        type: "Renew",
        customer_id: user?.user_type == 'C' ? user?.customer_id : null,
      }
      params = { ...params, ...Filter }
      console.log(params, 'params');

      const { data } = await CustomerServices.VisaProcessing(params)
      console.log(data);

      console.log(formatPermissionData(data?.permissions))
      setPermissions(formatPermissionData(data?.permissions))
      data?.permissions.forEach(e => {
        if (e?.route && e?.identifier && e?.permitted) {
          dispatch(addPermission(e?.route));
        }
      })
      setRenewVisas(data?.rows)
      setTotalCount(data?.count)
    } catch (error) {
      showErrorToast(error)
    } finally {
      // setLoader(false)
    }
  }
 const getRenewList2 = async (page, limit, filter) => {
    // setLoader(true)
    console.log(filter);

    try {
      const Page = page ? page : currentPage
      const Limit = limit ? limit : pageLimit
      // No filter passed (reload after an action) keeps the current filters, null (Reset) clears them
      const Filter = filter === null ? {} : filter ? { ...filters, ...filter } : (filters || {})
      setCurrentPage(Page)
      setPageLimit(Limit)
      setFilters(Filter)
      console.log('asasd');
      let params = {
        page: 1,
        limit: 99999,
        type: "Renew",
        customer_id: user?.user_type == 'C' ? user?.customer_id : null,
      }
      params = { ...params, ...Filter }
      console.log(params, 'params');

      const { data } = await CustomerServices.VisaProcessing(params)
    
      setVisas2(data?.rows)
    
    } catch (error) {
      showErrorToast(error)
    } finally {
      // setLoader(false)
    }
  }
  const downloadExcel = async (filteredData, companyName = "MABDE ERP") => {
  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet("Renewed Visa List")

  // Set professional header and footer
  worksheet.headerFooter.oddHeader =
    '&C&"Arial,Bold"&18RENEWED VISA LIST REPORT\n' +
    '&C&"Arial,Regular"&12' +
    companyName +
    "\n" +
    '&C&"Arial,Regular"&10Period: &D - &T\n' +
    '&L&"Arial,Regular"&8Generated on: ' +
    new Date().toLocaleDateString() +
    "\n" +
    '&R&"Arial,Regular"&8Page &P of &N'

  worksheet.headerFooter.oddFooter =
    '&L&"Arial,Regular"&8Confidential - Internal Use Only' +
    '&C&"Arial,Regular"&8This report contains renewed visa data as of ' +
    new Date().toLocaleDateString() +
    '&R&"Arial,Regular"&8Generated by: Visa Department\n' +
    '&C&"Arial,Regular"&8Powered by Premium Business Solutions'

  worksheet.headerFooter.evenFooter = worksheet.headerFooter.oddFooter

  // Set page setup for professional printing
  worksheet.pageSetup = {
    paperSize: 9, // A4
    orientation: "landscape",
    fitToPage: true,
    fitToWidth: 1,
    fitToHeight: 0,
    margins: {
      left: 0.7,
      right: 0.7,
      top: 1.0,
      bottom: 1.0,
      header: 0.3,
      footer: 0.3,
    },
  }

  // Add title section at the top of the worksheet
  const titleRow = worksheet.addRow(["RENEWED VISA LIST REPORT"])
  titleRow.getCell(1).font = {
    name: "Arial",
    size: 16,
    bold: true,
    color: { argb: "2F4F4F" },
  }
  titleRow.getCell(1).alignment = { horizontal: "center" }
  worksheet.mergeCells("A1:K1")

  const companyRow = worksheet.addRow([companyName])
  companyRow.getCell(1).font = {
    name: "Arial",
    size: 14,
    bold: true,
    color: { argb: "4472C4" },
  }
  companyRow.getCell(1).alignment = { horizontal: "center" }
  worksheet.mergeCells("A2:K2")

  const dateRow = worksheet.addRow([
    `Report Generated: ${new Date().toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    })} at ${new Date().toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    })}`,
  ])
  dateRow.getCell(1).font = {
    name: "Arial",
    size: 10,
    italic: true,
    color: { argb: "666666" },
  }
  dateRow.getCell(1).alignment = { horizontal: "center" }
  worksheet.mergeCells("A3:K3")

  // Add empty row for spacing
  worksheet.addRow([])

  const headers = [
    "VR No.",
    "Date",
    "Customer",
    "Candidate Name",
    "Passport Number",
    "Fee (AED)",
    "VAT (AED)",
    "Request Status",
    "Payment Status",
    "Status",
  ]

  const headerRow = worksheet.addRow(headers)
  headerRow.eachCell((cell) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "808080" }, // Gray
    }
    cell.font = { bold: true, color: { argb: "FFFFFF" } } // White bold
    cell.alignment = { horizontal: "center", vertical: "middle" }
    cell.border = {
      top: { style: "thin", color: { argb: "000000" } },
      left: { style: "thin", color: { argb: "000000" } },
      bottom: { style: "thin", color: { argb: "000000" } },
      right: { style: "thin", color: { argb: "000000" } },
    }
  })

  // Grand totals initialization
  let grandTotalFee = 0
  let grandTotalVAT = 0
  let approvedCount = 0
  let pendingCount = 0
  let rejectedCount = 0
  let paidCount = 0
  let unpaidCount = 0

  filteredData?.forEach((item) => {
    const fee = getRenewalChargeForVisa(item)
    const vat = fee * 0.05

    const row = worksheet.addRow([
      item?.candidate?.visa_id && item?.candidate?.serial_id
        ? `${item.candidate.visa_id}_${item.candidate.serial_id}`
        : "-",
      item?.created_at ? moment(item?.created_at).format("DD/MM/YYYY") : "-",
      item?.visa?.customer?.name || "-",
      item?.candidate?.name || "-",
      item?.candidate?.passport_number || "-",
      fee.toFixed(2),
      vat.toFixed(2),
      item?.request_status || "Pending",
      item?.payment_status || "Unpaid",
      item?.statuses?.[item?.statuses.length - 1]?.status || "-",
    ])

    // Format numerical columns
    row.getCell(6).numFmt = "#,##0.00" // Fee
    row.getCell(7).numFmt = "#,##0.00" // VAT

    // Color code request status
    const requestStatusCell = row.getCell(8)
    if (item?.request_status?.toLowerCase() === "approved") {
      requestStatusCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "C6EFCE" }, // Light green
      }
      requestStatusCell.font = { color: { argb: "006100" } } // Dark green
      approvedCount++
    } else if (item?.request_status?.toLowerCase() === "pending") {
      requestStatusCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFEB9C" }, // Light yellow
      }
      requestStatusCell.font = { color: { argb: "9C6500" } } // Dark yellow
      pendingCount++
    } else {
      requestStatusCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFC7CE" }, // Light red
      }
      requestStatusCell.font = { color: { argb: "9C0006" } } // Dark red
      rejectedCount++
    }

    // Color code payment status
    const paymentStatusCell = row.getCell(9)
    if (item?.payment_status?.toLowerCase() === "paid") {
      paymentStatusCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "C6EFCE" }, // Light green
      }
      paymentStatusCell.font = { color: { argb: "006100" } } // Dark green
      paidCount++
    } else {
      paymentStatusCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFC7CE" }, // Light red
      }
      paymentStatusCell.font = { color: { argb: "9C0006" } } // Dark red
      unpaidCount++
    }

    // Color code status
    const statusCell = row.getCell(10)
    const lastStatus = item?.statuses?.[item?.statuses.length - 1]?.status
    if (lastStatus === "Renewed") {
      statusCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "C6EFCE" }, // Light green
      }
      statusCell.font = { color: { argb: "006100" } } // Dark green
    } else if (lastStatus === "In Process") {
      statusCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFEB9C" }, // Light yellow
      }
      statusCell.font = { color: { argb: "9C6500" } } // Dark yellow
    }

    // Add borders to all cells
    // Real date cell so Excel filters by Year > Month > Day
    setExcelJsDateCell(row, 2, item?.created_at)

    row.eachCell((cell) => {
      cell.border = {
        top: { style: "thin", color: { argb: "000000" } },
        left: { style: "thin", color: { argb: "000000" } },
        bottom: { style: "thin", color: { argb: "000000" } },
        right: { style: "thin", color: { argb: "000000" } },
      }
      cell.alignment = { horizontal: "center", vertical: "middle" }
    })

    // Update grand totals
    grandTotalFee += fee
    grandTotalVAT += vat
  })

  // Add Grand Total row at the end
  setExcelJsAutoFilter(worksheet, headerRow, worksheet.lastRow?.number, headers.length)

  const grandTotalRow = worksheet.addRow([
    "GRAND TOTAL",
    `${filteredData?.length} Total Visas`,
    "",
    "",
    "",
    grandTotalFee.toFixed(2),
    grandTotalVAT.toFixed(2),
    `A:${approvedCount} | P:${pendingCount} | R:${rejectedCount}`,
    `Paid:${paidCount} | Unpaid:${unpaidCount}`,
    "",
  ])

  // Format grand total row
  grandTotalRow.eachCell((cell, colNumber) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "000000" }, // Black
    }
    cell.font = { bold: true, color: { argb: "FFFFFF" } } // White bold
    cell.alignment = { horizontal: "center", vertical: "middle" }
    cell.border = {
      top: { style: "thick", color: { argb: "000000" } },
      left: { style: "thick", color: { argb: "000000" } },
      bottom: { style: "thick", color: { argb: "000000" } },
      right: { style: "thick", color: { argb: "000000" } },
    }

    // Format numerical columns
    if (colNumber === 6 || colNumber === 7) {
      cell.numFmt = "#,##0.00"
    }
  })

  worksheet.columns = [
    { width: 15 }, // VR No.
    { width: 15 }, // Date
    { width: 25 }, // Customer
    { width: 25 }, // Candidate Name
    { width: 18 }, // Passport Number
    { width: 15 }, // Fee
    { width: 12 }, // VAT
    { width: 18 }, // Request Status
    { width: 18 }, // Payment Status
    { width: 20 }, // Status
  ]

  // Add empty rows for spacing before footer
  worksheet.addRow([])
  worksheet.addRow([])

  // Add the electronic generated report text with black border
  const reportRow = worksheet.addRow(["This is electronically generated report"])
  reportRow.getCell(1).font = {
    name: "Arial",
    size: 12,
    bold: false,
    color: { argb: "000000" },
  }
  reportRow.getCell(1).alignment = { horizontal: "center", vertical: "middle" }
  reportRow.getCell(1).border = {
    top: { style: "medium", color: { argb: "000000" } },
    left: { style: "medium", color: { argb: "000000" } },
    bottom: { style: "medium", color: { argb: "000000" } },
    right: { style: "medium", color: { argb: "000000" } },
  }
  worksheet.mergeCells(`A${reportRow.number}:K${reportRow.number}`)

  // Add empty row for spacing
  worksheet.addRow([])

  const system2 = worksheet.addRow(["Powered By: MangotechDevs.ae"])
  system2.getCell(1).font = {
    name: "Arial",
    size: 10,
    italic: true,
    color: { argb: "666666" },
  }
  system2.getCell(1).alignment = { horizontal: "center" }
  worksheet.mergeCells(`A${system2.number}:K${system2.number}`)

  // Add empty row for spacing
  worksheet.addRow([])

  const buffer = await workbook.xlsx.writeBuffer()
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  })

  saveAs(
    blob,
    `Renewed_Visa_List_${new Date()
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .replace(/\//g, "-")}.xlsx`,
  )
}

  const getData = async (formData) => {
    setLoading(true)
    console.log(formData);
    try {
      let params = {
        charges_type: 'rate'

      }

      const { data } = await SystemServices.getRates(params);


      setRates(data?.charges)




    } catch (error) {

    } finally {
      setLoading(false);
    }
  }

  const getBanks = async (page, limit, filter) => {
    // setLoader(true)
    try {





      const { data } = await SystemServices.getBanks()

      setBanks(data?.banks)
    } catch (error) {
      showErrorToast(error)
    } finally {
      // setLoader(false)
    }
  }
  // *For Handle Filter
  const handleFilter = () => {
    let data = {
      search: getValuesFilter("search"),
      from_date: fromDate,
      processing_status: status2?.id,
      to_date: toDate
    };
    saveListState(LIST_STATE_KEY, { ui: { search: getValuesFilter("search"), fromDate, toDate, status2 } })
    Debounce(() => getRenewList(1, '', data));
  };

  const handleSort = (key) => {
    let data = {
      sort_by: key,
      sort_order: sort,
    };
    Debounce(() => getRenewList(1, '', data));
  };
  useEffect(() => {
    const incomingFilters = null;
    // Coming back to the list (details page, menu): restore the last search
    const saved = !incomingFilters ? getListState(LIST_STATE_KEY) : null;
    if (saved?.filters) {
      setValueFilter("search", saved.ui?.search || "");
      setFromDate(saved.ui?.fromDate ? new Date(saved.ui.fromDate) : null);
      setToDate(saved.ui?.toDate ? new Date(saved.ui.toDate) : null);
      setStatus2(saved.ui?.status2 || null);
      setValueFilter("fromDate", saved.ui?.fromDate ? new Date(saved.ui.fromDate) : null);
      setValueFilter("toDate", saved.ui?.toDate ? new Date(saved.ui.toDate) : null);
      setValueFilter("status2", saved.ui?.status2 || null);
    }
    getRenewList2(1, "", saved?.filters)
    getRenewList(saved?.page || 1, saved?.limit || "", saved?.filters)
    getBanks()
    getData()

  }, [])


  return (
    <Box sx={{ p: 3 }}>
      <SimpleDialog
        open={requestDialog}
        onClose={() => { setRequestDialog(false); setApprovalDate(null) }}
        title={"Change Status?"}
      >
        <Box component="form" onSubmit={handleSubmit3(UpdateRequestStatus)}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <SelectField
                size={"small"}
                label={"Select Status :"}
                options={[
                  { id: 'Approved', name: "Approved" },
                  { id: 'Rejected', name: "Rejected" },

                ]}
                selected={status}
                onSelect={(value) => {
                  setStatus(value);
                  setValue3("status", value?.id);
                }}
                error={errors3?.status?.message}
                register={register3("status", {
                  required: "Please select status.",
                })}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <DatePicker
                label={"Date :*"}
                value={approvalDate}
                size={"small"}
                disableFuture={true}
                onChange={(date) => setApprovalDate(date)}
              />
            </Grid>
            {/* <Grid item xs={12} sm={12}>
              <DatePicker
                label={"Date :"}
                value={date}
                size={"small"}
                error={errors2?.date?.message}
                register={register2("date", {
                  required: "Please enter  date.",
                })}
                onChange={(date) => {
                  handleDate(date);
                  setValue2("date", date);
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ fontWeight: "bold" }}>Upload Document:</Box>
              <UploadFile
                Memo={true}
                accept={allowFilesType}
                error={errors?.document?.message}

                file={document}
                register={register("document", {
                  required: false,
                  onChange: async (e) => {
                    const path = await handleUploadDocument(e);
                    if (path) {
                      setDocument(path);
                    }
                  }
                })}
              />
              <Box sx={{ fontSize: "11px", marginTop: "-12px" }}>(Max File 25MB)</Box>
            </Grid> */}
            <Grid container sx={{ justifyContent: "center" }}>
              <Grid
                item
                xs={6}
                sm={6}
                sx={{
                  mt: 2,
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "25px",
                }}
              >
                <PrimaryButton
                  bgcolor={Colors.primary}
                  title="Yes,Confirm"
                  type="submit"
                />
                <PrimaryButton
                  onClick={() => { setRequestDialog(false) }}
                  bgcolor={"#FF1F25"}
                  title="No,Cancel"
                />
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </SimpleDialog>
      <SimpleDialog
        open={statusDialog}
        onClose={() => setStatusDialog(false)}
        title={"Change Status?"}
      >
        <Box component="form" onSubmit={handleSubmit(UpdateStatus)}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <SelectField
                size={"small"}
                label={"Select Status :"}
                options={getRenewStatusOptions(selectedVisa)}
                selected={status}
                onSelect={(value) => {
                  setStatus(value);
                  if (value?.id === "Renewed") {
                    setNewExpiryDate(getCalculatedNewExpiryDate(selectedVisa));
                  } else {
                    setNewExpiryDate(null);
                  }
                }}
                error={errors?.status?.message}
                register={register("status", {
                  required: "Please select status.",
                })}
              />
            </Grid>
            {(status?.id === "Rejected" || status?.id === "Canceled") && (
              <>
                {status?.id === "Canceled" && (
                  <Grid item xs={12} sm={12}>
                    <Box sx={{ fontWeight: "bold" }}>Type</Box>
                    <RadioGroup row value={cancelType} onChange={(e) => setCancelType(e.target.value)}>
                      <FormControlLabel value="inside" control={<Radio />} label="Inside" />
                      <FormControlLabel value="outside" control={<Radio />} label="Outside" />
                    </RadioGroup>
                  </Grid>
                )}
                <Grid item xs={12} sm={12}>
                  <LabelCustomInput
                    label={status?.id === "Canceled" ? "Cancellation Charges *:" : "Rejection Charges *:"}
                    StartLabel={"AED"}
                    register={register("rejectionCharges", {
                      required: "Enter charges",
                      onChange: (e) => setValue("rejectionTax", (Number.parseFloat(e.target.value || 0) * 0.05).toFixed(2)),
                    })}
                    error={errors?.rejectionCharges?.message}
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <LabelCustomInput
                    label={"Tax : "}
                    StartLabel={"AED"}
                    register={register("rejectionTax")}
                    disabled={true}
                  />
                </Grid>
                {status?.id === "Canceled" && (
                  <Grid item xs={12} sm={12}>
                    <InputField
                      label={"Grace Period :*"}
                      size={'small'}
                      fullWidth={true}
                      type={'number'}
                      placeholder={"Grace Period"}
                      error={errors?.grace?.message}
                      register={register("grace", { required: "Please enter grace period." })}
                    />
                  </Grid>
                )}
              </>
            )}
            {status?.id === "Absconder" && (
              <Grid item xs={12} sm={12}>
                <Box sx={{ textAlign: 'center' }}>A new Absconder request will be created and the renewal will be closed.</Box>
              </Grid>
            )}
            {status?.id === "Renewed" && (
              <Grid item xs={12} sm={12}>
                <DatePicker
                  label={"New Expiry Date :"}
                  value={newExpiryDate}
                  size={"small"}
                  onChange={(date) => {
                    setNewExpiryDate(date);
                  }}
                />
              </Grid>
            )}
            <Grid item xs={12} sm={12}>
              <DatePicker
                label={"Date :"}
                value={date}
                size={"small"}
                disableFuture={true}
                error={errors?.date?.message}
                register={register("date", {
                  required: "Please enter  date.",
                })}
                onChange={(date) => {
                  handleDate(date);
                  setValue("date", date);
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ fontWeight: "bold" }}>Upload Document : *</Box>
              <UploadFileSingle
                Memo={true}
                accept={allowFilesType}
                error={errors?.document?.message}

                file={document}
                register={register("document", {
                  required: document ? false : "Please upload document",
                  onChange: async (e) => {
                    const path = await handleUploadDocument(e);
                    if (path) {
                      setDocument(path);
                    }
                  }
                })}
              />

            </Grid>
            <Grid container sx={{ justifyContent: "center" }}>
              <Grid
                item
                xs={6}
                sm={6}
                sx={{
                  mt: 2,
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "25px",
                }}
              >
                <PrimaryButton
                  bgcolor={Colors.primary}
                  disabled={buttonDisabled || !document}
                  title="Yes,Confirm"
                  type="submit"
                />
                <PrimaryButton
                  onClick={() => setStatusDialog(false)}
                  bgcolor={"#FF1F25"}
                  title="No,Cancel"
                />
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </SimpleDialog>
      <SimpleDialog
        open={editDialog}
        onClose={() => setEditDialog(false)}
        title={"Edit Renewal Request"}
      >
        <Box component="form" onSubmit={handleSubmit5(EditRequest)}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <InputField label={"Candidate Name :"} size={"small"} disabled={true} value={selectedVisa?.candidate?.name || ""} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputField label={"Visa Type (In / Out) :"} size={"small"} disabled={true} value={selectedVisa?.candidate?.visa_type || ""} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box sx={{ fontWeight: "bold" }}>Visa Tenure :</Box>
              <RadioGroup row value={editTenure} onChange={(e) => setEditTenure(e.target.value)}>
                <FormControlLabel value="1 year" control={<Radio />} label="1 Year" />
                <FormControlLabel value="2 year" control={<Radio />} label="2 Year" />
              </RadioGroup>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Box sx={{ fontWeight: "bold" }}>Skip Medical :</Box>
              <RadioGroup row value={String(editSkipMedical)} onChange={(e) => setEditSkipMedical(e.target.value === 'true')}>
                <FormControlLabel value="true" control={<Radio />} label="Yes" />
                <FormControlLabel value="false" control={<Radio />} label="No" />
              </RadioGroup>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Box sx={{ fontWeight: "bold" }}>Skip EID :</Box>
              <RadioGroup row value={String(editSkipEid)} onChange={(e) => setEditSkipEid(e.target.value === 'true')}>
                <FormControlLabel value="true" control={<Radio />} label="Yes" />
                <FormControlLabel value="false" control={<Radio />} label="No" />
              </RadioGroup>
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputField label={"Passport Number :*"} size={"small"} error={errors5?.passport_number?.message} register={register5("passport_number", { required: "Please enter passport number." })} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <DatePicker label={"Passport Expiry :"} value={editPassportExpiry} size={"small"} onChange={(date) => setEditPassportExpiry(date)} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputField label={"Employee ID :"} size={"small"} register={register5("employee_id")} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputField label={"Designation :"} size={"small"} register={register5("visa_designation")} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputField label={"Phone :"} size={"small"} register={register5("phone")} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputField label={"Email :"} size={"small"} register={register5("email")} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputField label={"Basic Salary :"} size={"small"} type={"number"} register={register5("salary_basic")} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputField label={"Allowance :"} size={"small"} type={"number"} register={register5("salary_allowance")} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputField label={"Camp Location :"} size={"small"} register={register5("camp_location")} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputField label={"End Consumer :"} size={"small"} register={register5("end_consumer")} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputField label={"End Consumer Company :"} size={"small"} register={register5("end_consumer_company")} />
            </Grid>
            <Grid container sx={{ justifyContent: "center" }}>
              <Grid item xs={6} sm={6} sx={{ mt: 2, display: "flex", justifyContent: "space-between", gap: "25px" }}>
                <PrimaryButton bgcolor={Colors.primary} title="Update" type="submit" />
                <PrimaryButton onClick={() => setEditDialog(false)} bgcolor={"#FF1F25"} title="Cancel" />
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </SimpleDialog>
      <SimpleDialog
        open={editPaymentDialog}
        onClose={() => setEditPaymentDialog(false)}
        title={"Edit Payment"}
      >
        <Box component="form" onSubmit={handleSubmit6(EditPayment)}>
          <Grid container>
            <Grid item xs={12} sm={12}>
              <DatePicker
                label={"Payment Date :*"}
                value={date}
                size={"small"}
                onChange={(date) => handleDate(date)}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <SelectField
                size={"small"}
                label={"Payment Type :"}
                options={[
                  { id: "cash", name: "Cash" },
                  { id: "bank", name: "Bank" },
                  { id: "customer advance", name: "Customer Advance" },
                ]}
                selected={paymentType}
                onSelect={(value) => setPaymentType(value)}
              />
            </Grid>
            <Grid item xs={12} sm={12} mt={2}>
              <InputField
                label={"Description :"}
                size={"small"}
                rows={5}
                multiline={true}
                placeholder={"Description"}
                register={register6("edit_description")}
              />
            </Grid>
            <Grid container sx={{ justifyContent: "center" }}>
              <Grid item xs={6} sm={6} sx={{ mt: 2, display: "flex", justifyContent: "space-between", gap: "25px" }}>
                <PrimaryButton bgcolor={Colors.primary} title="Update" type="submit" />
                <PrimaryButton onClick={() => setEditPaymentDialog(false)} bgcolor={"#FF1F25"} title="Cancel" />
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </SimpleDialog>
      <SimpleDialog
        open={paymentDialog}
        onClose={() => setPaymentDialog(false)}
        title={"Change Payment Status?"}
      >
        <Box component="form" onSubmit={handleSubmit2(UpdatePaymentStatus)}>
          <Grid container>
            <Grid item xs={12} sm={12}>
              <DatePicker
                label={"Payment Date :"}
                value={date}
                size={"small"}
                error={errors2?.date?.message}
                register={register2("date", {
                  required: date ? false : "Please enter  date.",
                })}
                onChange={(date) => {
                  handleDate(date);
                  setValue2("date", date);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <SelectField
                size={"small"}
                label={"Payment Type :"}
                options={[
                  { id: "cash", name: "Cash" },
                  { id: "bank", name: "Bank" },
                  { id: "customer advance", name: "Customer Advance" },
                  // { id: "cheque", name: "Cheque" },

                ]}
                selected={paymentType}
                onSelect={(value) => {
                  setPaymentType(value);
                }}
                error={errors2?.status?.message}
                register={register2("status", {
                  required: "Please select status.",
                })}
              />
            </Grid>
            {/* <Grid item xs={12} sm={12}>
              <SelectField
                size={"small"}
                label={"Bank :"}
                options={banks}
                selected={selectedBank}
                onSelect={(value) => {
                  setSelectedBank(value);
                }}
                error={errors2?.banks?.message}
                register={register2("bank", {
                  required: "Please select bank.",
                })}
              />
            </Grid> */}
            <Grid item xs={12} sm={12}>
              <LabelCustomInput
                label={"Amount : "}
                StartLabel={"AED"}
                disabled={true}
                register={register2("amount", {
                  required: "Enter year inside rate",
                })}
              />
            </Grid>
            <Grid item xs={12} sm={12} mt={2}>
              <InputField
                label={"Description :"}
                size={"small"}
                rows={5}
                multiline={true}
                placeholder={"Description"}
                error={errors2?.description?.message}
                register={register2("description", {
                  required: false,
                })}
              />
            </Grid>
            <Grid container sx={{ justifyContent: "center" }}>
              <Grid
                item
                xs={6}
                sm={6}
                sx={{
                  mt: 2,
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "25px",
                }}
              >
                <PrimaryButton
                  bgcolor={Colors.primary}
                  title="Yes,Confirm"
                  type="submit"
                />
                <PrimaryButton
                  onClick={() => setPaymentDialog(false)}
                  bgcolor={"#FF1F25"}
                  title="No,Cancel"
                />
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </SimpleDialog>

      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <Typography sx={{ fontSize: "24px", fontWeight: "bold" }}>
          Renewed Visa List {totalCount ? <span style={{ fontSize: "18px", color: "#0076bf" }}>({totalCount})</span> : ""}
        </Typography>
        <PrimaryButton
          bgcolor={'#0076bf'}
          title="Download Excel"
          onClick={() => downloadExcel(visas2)}
          loading={loading}
        />
      </Box>

      {/* Filters */}
      <Box>
        <Grid container spacing={2} alignItems={'center'}>
          <Grid item xs={3} mt={1}>
            <InputField
              label={"Search :"}
              size={'small'}
              fullWidth={true}
              placeholder={"Search"}
              error={errorsFilter?.search?.message}
              register={registerFilter("search")}
            />
          </Grid>
          <Grid item xs={3}>
            <DatePicker
              label={" From Date  :"}
              value={fromDate}

              size={'small'}
              maxDate={new Date()}
              error={errorsFilter?.fromDate?.message}
              register={registerFilter("fromDate")}
              onChange={(date) => {
                handleDate2(date)
                setValueFilter('fromDate', date)
              }

              }
            />
          </Grid>
          <Grid item xs={3}>
            <DatePicker
              label={" To Date  :"}
              value={toDate}
              maxDate={new Date()}
              size={'small'}
              minDate={new Date(fromDate)}
              error={errorsFilter?.toDate?.message}
              register={registerFilter("toDate")}
              onChange={(date) => {
                handleDate3(date)
                setValueFilter('toDate', date)
              }

              }
            />
          </Grid>
          <Grid item xs={3} mt={1}>
            <SelectField
              size={'small'}
              label={'Select Status :'}

              options={[{ id: "In Process", name: "In Process" },
              { id: "Pending", name: "Pending" },
              { id: "Medical", name: "Medical" },
              { id: "EID", name: "EID" },
              { id: "Renewed", name: "Renewed" },
              { id: "Rejected", name: "Rejected" },
              { id: "Canceled", name: "Canceled" },
              { id: "Absconder", name: "Absconder" },]}
              selected={status2}
              onSelect={(value) => {
                setStatus2(value)


              }}
              error={errorsFilter?.status2?.message}
              register={registerFilter("status2")}
            />
          </Grid>
          {/* <Grid item xs={3} >
                        <LabelCustomInput type={'text'} bgcolor={'#FAFAFA'} color={Colors.primary} border={'3px solid #FAFAFA'} StartLabel={'By Customers'} placeholder={'Enter Name'}   register={register("payroll")} />
                    </Grid>
                    <Grid item xs={3} >
                        <LabelCustomInput bgcolor={'#FAFAFA'} color={Colors.primary} border={'3px solid #FAFAFA'} StartLabel={'By Commission'} placeholder={'Enter Name'}   register={register("payroll")} />
                    </Grid>
                    <Grid item xs={3} >
                        <LabelCustomInput bgcolor={'#FAFAFA'} color={Colors.primary} border={'2px solid #FAFAFA'} StartLabel={'By Date'} placeholder={'Enter Name'}   register={register("payroll")} />
                    </Grid> */}
          <Grid
            item
            xs={2}
            display={"flex"}
            justifyContent={"flex-end"}
            gap={2}
            mt={2.5}
          >
            <PrimaryButton
              bgcolor={"#0076bf"}
              textcolor={Colors.white}
              // border={`1px solid ${Colors.primary}`}
              title="Reset"
              onClick={() => {
                setFilters('');
                setFromDate(null);
                setToDate(null);
                setStatus2(null);
                setValueFilter('search', '');
                setValueFilter('fromDate', null);
                setValueFilter('toDate', null);
                setValueFilter('status2', null);
                saveListState(LIST_STATE_KEY, { ui: null }); getRenewList(1, '', null)
              }}
              loading={loading}
            />
            <PrimaryButton
              bgcolor={Colors.buttonBg}
              title="Search"
              onClick={() => handleFilter()}
              loading={loading}
            />
          </Grid>
        </Grid>

        <Grid item md={11}>
          {renewVisas?.length > 0 && (
            <Box>
              <Grid container mb={2}></Grid>

              {renewVisas && (
                <Fragment>
                  <PDFExport
                    ref={contentRef}
                    landscape={true}
                    paperSize="A4"
                    margin={5}
                    fileName="Import Customers"
                  >
                    <TableContainer
                      component={Paper}
                      sx={{
                        maxHeight: "calc(100vh - 200px)",
                        mt: 5,
                        backgroundColor: "transparent",
                        boxShadow: "none !important",
                        borderRadius: "0px !important",
                      }}
                    >
                      <Table stickyHeader sx={{ minWidth: 500 }}>
                        <TableHead>
                          <Row>
                            {tableHead.map((cell, index) => (
                              <Cell
                                style={{
                                  textAlign:
                                    cell?.name == "VR No." ? "center" : "left",
                                  paddingRight:
                                    cell?.name == "VR No." ? "15px" : "50px",
                                }}
                                className="pdf-table"
                                key={index}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "flex-end",
                                  }}
                                >
                                  {cell?.name}{" "}
                                  {cell?.name == "Date" && (
                                    <>
                                      &nbsp;
                                      <span
                                        style={{
                                          height: "20px",
                                          cursor: "pointer",
                                        }}
                                      >
                                        <Box
                                          component={"img"}
                                          onClick={() => {
                                            setSort(
                                              sort == "asc" ? "desc" : "asc"
                                            );
                                            handleSort(cell?.key);
                                          }}
                                          src={Images.sortIcon}
                                          width={"18px"}
                                        ></Box>
                                      </span>
                                    </>
                                  )}
                                </Box>
                              </Cell>
                            ))}
                          </Row>
                        </TableHead>
                        <TableBody>
                          {renewVisas?.map((item, index) => {
                            return (
                              <Row
                                key={index}
                                sx={{
                                  border: "1px solid #EEEEEE !important",
                                }}
                              >
                                <Cell
                                  style={{ textAlign: "left" }}
                                  className="pdf-table"
                                >
                                  {item?.candidate?.visa_id + "_" + item?.candidate?.serial_id}
                                </Cell>
                                <Cell
                                  style={{ textAlign: "left" }}
                                  className="pdf-table"
                                >
                                  {moment(item?.created_at).format('DD/MM/YYYY')}
                                </Cell>
                                <Cell
                                  style={{ textAlign: "left" }}
                                  className="pdf-table"
                                >
                                  {item?.visa?.customer?.name}
                                </Cell>
                                <Cell
                                  style={{ textAlign: "left" }}
                                  className="pdf-table"
                                >
                                  {item?.candidate?.name}
                                </Cell>
                                <Cell
                                  style={{ textAlign: "left" }}
                                  className="pdf-table"
                                >
                                  {item?.candidate?.passport_number}
                                </Cell>
                                <Cell
                                  style={{ textAlign: "left" }}
                                  className="pdf-table"
                                >
                                  {getRenewalChargeForVisa(item).toFixed(2)}
                                </Cell>
                                <Cell
                                  style={{ textAlign: "left" }}
                                  className="pdf-table"
                                >
                                  {(getRenewalChargeForVisa(item) * 0.05).toFixed(2)}
                                </Cell>
                                <Cell
                                  style={{ textAlign: "left" }}
                                  className="pdf-table"
                                >
                                  <Box
                                    component={"div"}
                                    sx={{ cursor: "pointer", display: 'flex !important', justifyContent: 'flex-start !important' }}
                                    onClick={() => {
                                      if (permissions?.request_update) {
                                        setStatus({ id: item?.request_status, name: item?.request_status })
                                        setRequestDialog(true);
                                        setSelectedVisa(item);
                                      }
                                    }}
                                  >
                                    <Box
                                      component={"img"}
                                      src={
                                        item?.request_status == "Approved"
                                          ? Images.successIcon
                                          : Images.errorIcon
                                      }
                                      width={"13px"}
                                    ></Box>
                                    {item?.request_status == "Approved" ? 'Approved' : item?.request_status == "pending" ? "Pending" : 'Rejected'}
                                  </Box>
                                </Cell>
                                <Cell
                                  style={{ textAlign: "left" }}
                                  className="pdf-table"
                                >
                                  <Box
                                    component={"div"}
                                    sx={{ cursor: "pointer", display: 'flex !important', justifyContent: 'flex-start !important' }}
                                    onClick={() => {
                                      if (item?.payment_status == "paid" && permissions?.payment_update) {
                                        setSelectedVisa(item);
                                        setDate(item?.payment?.payment_date ? new Date(item?.payment?.payment_date) : null);
                                        setPaymentType(item?.payment?.payment_type ? { id: item?.payment?.payment_type?.toLowerCase(), name: item?.payment?.payment_type } : null);
                                        setValue6('edit_description', item?.payment?.description || '');
                                        setEditPaymentDialog(true);
                                        return;
                                      }
                                      if (item?.payment_status != "paid" && item?.request_status == "Approved") {
                                        if (permissions?.payment_update) {

                                          setPaymentDialog(true);

                                          const renewalFee = getRenewalChargeForVisa(item);
                                          setValue2('amount', (renewalFee * 1.05).toFixed(2));

                                          setSelectedVisa(item);
                                        }
                                      }

                                    }}
                                  >
                                    <Box
                                      component={"img"}
                                      src={
                                        item?.payment_status == "paid"
                                          ? Images.successIcon
                                          : Images.errorIcon
                                      }
                                      width={"13px"}
                                    ></Box>
                                    {item?.payment_status == "paid" ? "Paid" : 'Unpaid'}
                                  </Box>
                                </Cell>
                                <Cell
                                  style={{ textAlign: "left" }}
                                  className="pdf-table"
                                >
                                  <Box
                                    component={"div"}
                                    sx={{ cursor: "pointer", display: 'flex !important', justifyContent: 'flex-start !important' }}
                                    onClick={() => {
                                      setDate(null)
                                      setStatus(null)
                                      setDocument(null)
                                      setNewExpiryDate(null)
                                      if (permissions?.status_update && !RENEW_CLOSED_STATUSES.includes(item?.statuses[item?.statuses.length - 1]?.status)) {
                                        setStatus(null);
                                        setCancelType("inside");
                                        setStatusDialog(true);
                                        setSelectedVisa(item);
                                      }
                                    }}
                                  >
                                    <Box
                                      component={"img"}
                                      src={
                                        item?.statuses[item?.statuses.length - 1].status == "In Process"
                                          ? Images.pendingIcon
                                          : item?.statuses[item?.statuses.length - 1].status == "Renewed" ?
                                            Images.successIcon : Images.orangeCircle
                                      }
                                      width={"13px"}
                                    ></Box>
                                    {item?.statuses[item?.statuses.length - 1].status}
                                  </Box>
                                </Cell>
                                <Cell style={{ textAlign: 'left' }} className="pdf-table">
                                  <Box>

                                    {permissions?.details && <Box component={'img'} src={Images.detailIcon} onClick={() => navigate(`/renewed-detail/${item?.id}`)} width={'35px'}></Box>}
                                    {permissions?.request_update && item?.request_status?.toLowerCase() == "pending" && (
                                      <IconButton onClick={() => openEditRequest(item)} title="Edit Request">
                                        <EditIcon sx={{ cursor: "pointer" }} />
                                      </IconButton>
                                    )}
                                    {permissions?.invoice && <Box component={'img'} onClick={() => {

                                      if (permissions?.invoice) {

                                        navigate(`/renew-invoice/${item?.id}`)
                                      }


                                    }} sx={{ cursor: "pointer" }} src={Images.invoiceIcon} width={'35px'}></Box>}
                                    {/* <Box component={'img'} src={Images.deleteIcon} width={'35px'}></Box>  */}
                                  </Box>
                                </Cell>

                              </Row>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </PDFExport>
                  {/* ========== Pagination ========== */}
                  <Pagination
                    currentPage={currentPage}
                    pageSize={pageLimit}
                    onPageSizeChange={(size) => getRenewList(1, size.target.value, filters)}
                    tableCount={customerQueue?.length}
                    totalCount={totalCount}
                    onPageChange={(page) => getRenewList(page, "", filters)}
                  />
                </Fragment>
              )}

              {loader && <CircleLoading />}
            </Box>
          )}
        </Grid>
      </Box>
    </Box>
  );
}

export default VisaList;
